import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/lp-sticky-cta.css';

const LPStickyCTA = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/register');
  };

  return (
    <div className="lp-sticky-cta">
      <div className="lp-sticky-cta__container">
        <div className="lp-sticky-cta__text">
          <span className="lp-sticky-cta__icon">🌸</span>
          <span className="lp-sticky-cta__label">登録無料</span>
        </div>
        <button
          className="lp-sticky-cta__button"
          onClick={handleClick}
        >
          つむぎと話してみる →
        </button>
      </div>
    </div>
  );
};

export default LPStickyCTA;
